module.exports = __webpack_public_path__ + "img/horizontal_6_4_9016.23fcf945.png";